import { colors } from "@mui/material";

const colorConfigs = {
  //Barra de Menu
  sidebar: {
    bg: "#808080", //"#69f0ae",
    color: "#000000",
    hoverBg: "#33eb91",
    activeBg: "#b9f6ca"
  },
  topbar: {
    bg: "#fff",
    color: "#000"
  },
  mainBg: colors.grey["100"]
};

export default colorConfigs;